<template>
	<div style="width:100%;height:100%">
		<!-- 功能按钮 -->
		<buttonlist
			@help="help"
			@opentable="opentable"
			@search="search"
			@reflash="reflash"
			@exps="exp"
			@imp="imp"
			ref="SetBtn"
		></buttonlist>
		<!-- 功能按钮 -->
		<!-- 表格 -->
		<wTable
				id="xpane-0"
				:data="datajson"
				:loading="loading"
				queryData="SchQuotationBatchViewInfo"
				:filter_language="['Valid_flag','Check_flag','preferred_flag','avl_flag']"
				:filter_thousandth="['Supply_Limit','Shipment_Cycle']"
				:filter_thousandth_purprice="['price','net_price','Unit_Price','Net_unit_price']"
				:header="tableHeader"
				:option="tableOption"
				:row-class-name="tableRowClassName"
				:checkflg="false"
				ref="singleTable"
		></wTable>
		<!--<el-table
			:data="datajson"
			v-loading="loading"
			:highlight-current-row="false"
			:height="tableHeight"
			border
			stripe
			size="mini"
			tab-click="selectInfo(0)"
			header-row-class-name="headerclass"
			:row-class-name="tableRowClassName"
			style="width: 100%; margin-top:0px"
		>
			<el-table-column show-overflow-tooltip prop="EXCLUSIVELY_ID" label="ID" v-if="false"></el-table-column>
			<el-table-column show-overflow-tooltip prop="partID" :label="$t('getapi[1297]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="Valid_flag" :label="$t('getapi[4048]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="batch_floor_limit" :label="$t('getapi[1289]')" align="right"></el-table-column>
			<el-table-column show-overflow-tooltip prop="Vender_Code" :label="$t('getapi[1287]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="Vender_Name" :label="$t('getapi[1197]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="part_code" :label="$t('getapi[1299]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="part_name" :label="$t('getapi[1164]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="part_version" :label="$t('getapi[1300]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="ITEM_NAME" :label="$t('getapi[137]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="price" :label="$t('getapi[1292]')" align="right"></el-table-column>
			<el-table-column show-overflow-tooltip prop="net_price" :label="$t('getapi[1352]')" align="right"></el-table-column>
			<el-table-column show-overflow-tooltip prop="pur_MeasurementUnit" :label="$t('getapi[1166]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="exchange_rate" :label="$t('getapi[1304]')" align="right"></el-table-column>
			<el-table-column show-overflow-tooltip prop="Tax_Rate" :label="$t('getapi[1225]')" align="right"></el-table-column>
			<el-table-column show-overflow-tooltip prop="Currency_Code" :label="$t('getapi[1227]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="Supply_Limit" :label="$t('getapi[1305]')" align="right"></el-table-column>
			<el-table-column show-overflow-tooltip prop="vender_Part_Code" :label="$t('getapi[1301]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="Shipment_Cycle" :label="$t('getapi[1306]')" align="right"></el-table-column>
			<el-table-column show-overflow-tooltip prop="Packaging_Spec" :label="$t('getapi[1307]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="Check_flag" :label="$t('getapi[1308]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="preferred_flag" :label="$t('getapi[1309]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="Effective_Date" :label="$t('getapi[1310]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="avl_flag" label="AVL"></el-table-column>
			<el-table-column show-overflow-tooltip prop="Unit_Price" :label="$t('getapi[6017]')" align="right"></el-table-column>
			<el-table-column show-overflow-tooltip prop="Net_unit_price" :label="$t('getapi[6018]')" align="right"></el-table-column>
			<el-table-column show-overflow-tooltip prop="Remark" :label="$t('getapi[143]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="Create_Person" :label="$t('getapi[1311]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="Create_Time" :label="$t('getapi[135]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="modify_person" :label="$t('getapi[1312]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="modify_time" :label="$t('getapi[1210]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="Audit_Person" :label="$t('getapi[1313]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="Audit_Time" :label="$t('getapi[732]')"></el-table-column>
		</el-table>-->
		<!-- 表格 -->
		<!-- 分页 -->
		<el-row class="page">
			<el-col :span="16">
				<el-pagination
					@size-change="handleSizeChange"
					@current-change="handleCurrentChange"
					:page-sizes="[50, 100, 200, 300, 400]"
					:page-size="PageSize"
					background
					small
					pager-count="5"
					layout="total, sizes, prev, pager, next, jumper"
					:total="total"
				></el-pagination>
			</el-col>
			<el-col :span="8">
				<div style="text-align: right;line-height: 30px;color: #545c64;font-size: 95%;">{{$t('getapi[7980]')}}:{{ DbTbNames }}</div>
			</el-col>
		</el-row>
		<!-- 搜索弹框 -->
		<serce :isVisible="isVisible" queryData="SchQuotationBatchViewInfo" ref="ser" @getser="serclick"></serce>
		<ctable :isVisible="false" :title="$t('getapi[6014]')" queryData="SchQuotationBatchViewInfo" tabNo="0" ref="ctab"
				@getctab="sortclick"></ctable>
	</div>
</template>

<script>
import Common from '@/components/Common';
export default {
	name:'ppbatchoverview',
    computed: {
        tableOption() {
            return {
                border: true,
                height: this.$windowSize.tableHeight3,
                maxHeight: this.$windowSize.tableHeight3,
            }
        },
        tableHeight(){
            return this.$windowSize.tableHeight3
        }
    },
	data() {
		return {
            tableHeader: [],
			DbTbNames: '', //表名
			datajson: [],
			PageIndex: 1,
			PageSize: this.$http.getPageSize('ppbatchoverview'),
			SelectIndex: 0,
			total: 0, // 数据总量
			loading: false, // 主表加载状态
			queryData: [], // 查询数组
			isVisible: false,
            scrollTop:0,
		};
	},
	create() {},
	beforeMount() {},
	mounted() {
		let that = this;
        that.colsort();
		that.authority();
	},
    activated () {
        let that = this
        setTimeout(() => {
            that.$refs.singleTable.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                that.scrollTop = res.target.scrollTop
            },false)
        }, 5000);
        // 路由跳转回来滚动到离开时的位置
        this.$nextTick(()=> {
            setTimeout(() => {
                this.$refs.singleTable.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
            }, 13)
        })

    },
	methods: {
        colsort() {
            let that = this;
            that.$loadviewfields.Fileds('SchQuotationBatchViewInfo', 0, PFileds => {
                that.tableHeader = PFileds;
            });
        },
        sortclick(val) {
            if (val == 1) {
                this.colsort();
            }
        },
        // 修改表格顺序
        opentable() {
            this.$refs.ctab.clearInputs(true);
        },
        help(){
            this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[6014]"),this.$t("getapi[17]"));
        },
		authority() {
			let that = this;
            if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                that.$refs.SetBtn.SetOneBtnEnable('help',true);
            }
            that.$refs.SetBtn.SetOneBtnEnable('ctabel', true);
			//只读权
			if (that.$limits.authority('plv2', 153, 1) >= 1) {
				if (that.total > 0) {
					that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
				} else {
					that.$refs.SetBtn.SetButtonEnable('search,refresh');
				}
			}
		},
		//表格背景
		tableRowClassName({ row, rowIndex }) {
			if (row.enable_flag == '是') {
				return 'warning-row';
			}
			if (row.version_status == '不可用') {
				return 'dark-row';
			}
		},
		//获取查询条件
		serclick(val) {
			this.queryData = val;
			this.intidata();
		},
		//修改页数
		handleSizeChange(val) {
			this.PageSize = val;
			this.intidata();
			this.authority();
		},
		//跳页
		handleCurrentChange(val) {
			this.PageIndex = val;
            this.$http.savePageSize('ppbatchoverview',val)
			this.intidata();
			this.authority();
		},
		// 获取数据
		intidata() {
			let that = this;
			that.loading = true;
			this.isVisible = false;
			let pm = {
				query_Condition: '',
				query_field_type: '',
				query_field_name: '',
				row_sign: '',
				query_sort: ''
			};
			let parm = {
				PageIndex: that.PageIndex,
				PageSize: that.PageSize,
				SelectIndex: that.SelectIndex,
				Param: []
			};
			that.queryData.forEach(item => {
				if(item.query_Condition==''||item.query_Condition.length>0) {
					pm = {
						row_sign: item.row_sign,
						query_Condition: item.query_Condition,
						query_sort: item.query_sort,
						query_field_type: item.Query_Field_Type,
						query_field_name: item.Query_Field_Name
					};
					parm.Param.push(pm);
				}
			});
			that.$http.urlpost('/Sch/QuotationBatch/DataList', parm, function(res) {
				if (res.Success == 1) {
					that.datajson = res.DataContent;
					that.total = res.Totals;
					that.DbTbNames = res.DbTbNames;
				}
				that.loading = false;
				that.authority();
                that.$nextTick(function(){
                    that.$processdata.initForm(that.SelectIndex)
                });
			});
		},

		// 查询
		search() {
			this.isVisible = true;
			this.$refs.ser.clearInput(this.isVisible, 'SchQuotationBatchViewInfo');
		},
		// 刷新
		reflash() {
			this.intidata();
		},
		// 导出
		exp() {
			/*let that = this;
			let datac = [];
			for (let i = 0; i < that.queryData.length; i++) {
				datac.push({
					query_Condition: that.queryData[i].query_Condition,
					query_field_type: that.queryData[i].Query_Field_Type,
					query_field_name: that.queryData[i].Query_Field_Name,
					query_sort: that.queryData[i].query_sort,
					row_sign: that.queryData[i].row_sign
				});
			}
			let parm = {
				PageIndex: that.PageIndex,
				PageSize: that.PageSize,
				SelectIndex: that.SelectIndex,
				Ids: '',
				Param: datac
			};
			that.$http.urlpost('/Sch/QuotationBatch/ListToExecl', parm, function(res) {
				if (res.Success == 1) {
					let hrefurl = Common.Url + res.DataContent.URL;
					window.open(hrefurl);
				}
			});*/
            let that = this;
            let datac = [];
            for (let i = 0; i < that.queryData.length; i++) {
                datac.push({
                    query_Condition: that.queryData[i].query_Condition,
                    query_field_type: that.queryData[i].Query_Field_Type,
                    query_field_name: that.queryData[i].Query_Field_Name,
                    query_sort: that.queryData[i].query_sort,
                    row_sign: that.queryData[i].row_sign
                });
            }
            let parm = {
                query_sign: "SchQuotationBatchViewInfo",
                fromname: that.$t("getapi[6014]"),
                SelectIndex: that.SelectIndex,
                MultyVer: that.$processdata.getLanguage(),
                Param: datac
            };
            that.$processdata.commonExport(parm)
		},
		//导入
		imp() {
			let item = {
				//label: '批量修改采购单价',
                label: '通用导入',
				name: 'exp',
				path: '/exp/20',
				url: '/exp/20',
				icon: 'video-play'
			};
			this.$router.push({ path: '/exp/20' });
			this.$store.commit('selectMenu', item);
		}
	}
};
</script>

<style lang="scss" scoped>
span.title {
	width: 100%;
	display: flex;
	height: 40px;
	line-height: 40px;
}

span.title .el-switch {
	display: inline-block;
	margin: 8px 30px;
}
.bbl {
	margin: 10px auto;
	span {
		width: 70px;
		text-align: left;
		line-height: 40px;
		display: inline-block;
	}
}
</style>
